import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
    .use(initReactI18next) // passa i18n para o react-i18next.
    .init({
        resources: {
            pt: {
                translation: {
                    "welcome": "Bem-vindo ao AgroInsider!",
                    "calculate_carbon_footprint": "Iniciar Cálculo",
                    "find_more": "Saber mais",
                    "initial_page": "Página Inicial",
                    "quit": "Sair",
                    "general-information": "Informações Gerais",
                    "CarbonFootprint": {
                        "title": "A sua pegada de Carbono",
                        "ANIMAL_PRODUCTION": "Produção Animal",
                        "VEGETAL_PRODUCTION": "Produção Agrícola",
                        "FUEL_PRODUCTION": "Combustíveis",
                        "EMISSIONS": "Emissões",
                    },
                    "APROXIMATED_VALUES_INFORMATION": "Os valores apresentados são aproximados e baseados em dados de atividades similares.",
                    "KnowMore": {
                        "title": "Aprender",
                        "description": "Conheça a pegada de carbono na agriculura.",
                        "item1-header": "O que é pegada de carbono?",
                        "item1-content": "A pegada de carbono em agricultura é normalmente definida como a quantidade de gases de efeito de estufa (GEE) que a atividade produtora emite para a atmosfera por uma tonelada de produto produzido (Ex. 0.5 tonCO2eq/Ton de milho).",
                        "item1-content2": "Os GEE em agricultura são normalmente o dióxido de carbono (CO2), o metano (CH4) e o óxido Nitroso (N2O) contudo, podemos converter estes três tipos de GEE em apenas um único que seja equivalente em termos do aquecimento global da atmosfera e que é normalmente conhecido como o dióxido de carbono equivalente (CO2eq).",

                        "item2-header": "Como contribui a agricultura para as emissões de carbono?",
                        "item2-content": "A agricultura contribui para as emissões de carbono porque desenvolve atividades e usa fatores de produção que normalmente emitem carbono para a atmosfera.",
                        "item2-content2": "Como exemplo poderemos referir a queima de combustíveis fósseis, a utilização de fertilizantes minerais, a criação de animais pelo metano e pela gestão dos resíduos que produzem, a produção de arroz pelo metano que emite por ser uma cultura alagada.",

                        "item3-header": "Que práticas agrícolas ajudam a reduzir a pegada de carbono?",
                        "item3-content": "Existem muitas práticas agrícolas que podem reduzir a pegada de carbono do produto (ex. alimento).",
                        "item3-content2": "Reduzir a pegada de carbono de um alimento pode ser possível quando, por exemplo:",
                        "item3-content3": "reduzimos o número de passagens de operações agrícolas num determinado terreno poupando gasóleo (Ex. Converter a preparação da cama da semente de mobilização convencional do solo para sementeira direta ou então utilizar equipamento que numa só passagem realize várias operações ao mesmo tempo);",
                        "item3-content4": "deixamos de usar por exemplo ureia e passamos a usar outro tipo de fertilizante azotado com um fator de emissão muito mais baixo;",
                        "item3-content5": "utilizamos por exemplo animais que já fazem parte da exploração no controle de infestantes de algumas culturas arborícolas (ex. vinha, olival) por forma a evitar o controle de infestantes com máquinas ou herbicidas e dessa forma poupar o gasóleo que não se gasta.",
                        "PERSONALIZED_CONSULTING": "Consulta personalizada",
                    },
                    "CarbonImprovement": {
                        "title": "Melhorar",
                        "description": "Na Agroinsider, oferecemos consultoria personalizada baseada em dados cientificos e práticas agrícolas inovadoras, adaptadas às necessidades específicas de cada cliente.",
                        "card1Title": "Redução de Emissões",
                        "card1Description": "Desenvolvemos um plano personalizado para diminuir a sua pegada de carbono, com base em tecnologias de ponta.",
                        "card2Title": "Implementação de Práticas Sustentáveis",
                        "card2Description": "Apoiamos na integração de soluções sustentáveis na sua exploração, e garantimos uma transição eficiente para a neutralidade carbónica.",
                        "card3Title": "Monitorização e Relatórios",
                        "card3Description": "Acompanhamos continuamente e fornecemos relatórios para garantir que as metas de redução de carbono sejam atingidas",
                        "card4Title": "Participação no Mercado de Carbono",
                        "card4Description": "Ajudamos a posicionar-se estrategicamente no mercado de carbono, convertendo reduções de emissões em créditos de carbono.",

                        "HelpTitle": "Ajuda",
                        "HelpDescription": "Quer saber mais sobre como podemos ajudar? Preencha o formulário abaixo e entraremos em contacto para apresentar as soluções mais adequadas à sua exploração.",
                        
                        
                    },

                    "homepage_carbon_title_logo": "Calcule, reduza e transforme a sua pegada de carbono",
                    "homepage_carbon_description_logo1": "Aqui pode calcular a sua pegada de carbono, aprender como reduzi-la",
                    "homepage_carbon_description_logo2": "e a melhorar a sustentabilidade da sua herdade.",
                    "homepage_carbon_title1": "Medir",
                    "homepage_carbon_title2": "Aprender",
                    "homepage_carbon_title3": "Melhorar",
                    "homepage_carbon_description1": "Calcule facilmente a sua pegada de carbono.",
                    "homepage_carbon_description2": "Saiba mais sobre a pegada de carbono na agricultura.",
                    "homepage_carbon_description3": "Conheça estratégias para diminuir a sua pegada de carbono.",
                    "FarmProfile": {
                        "title": "Perfil da Herdade",
                        "description": "Recolha de informações sobre as suas atividades agrícolas. Os dados são utilizados para calcular as emissões de CO2 e ajudar a reduzir o impacto ambiental da sua herdade. Por favor, preencha todas as seções com atenção.",
                        "farmName": "Nome da Herdade",
                        "location": "Localização Geográfica",
                        "size": "Área da herdade (em hectares)",
                        "farmType": "Tipo de herdade",
                        "animalProduction": "Produção Animal",
                        "agriculturalProduction": "Produção Agrícola",
                        "mixed": "Mista",
                        "submit": "Avançar",
                    },
                    "AnimalProduction": {
                        "title": "Produção Animal",
                        "description": "Qual ou quais animais produz? Informe o número de animais.",
                        "descriptionPart2": "Se produz suínos, escolha o tipo de produção: Extensiva ou Intensiva.",
                        "spicesOption1": "Bovinos carne",
                        "spicesOption2": "Bovinos leite",
                        "spicesOption3": "Ovinos",
                        "spicesOption4": "Caprinos",
                        "spicesOption5": "Suínos",
                        "spicesOption6": "Equinos",
                        "methods": "Qual o método de criação utilizado?",
                        "radioOption1": "Pastagem Intensiva",
                        "radioOption2": "Pastagem Semi-Intensiva",
                        "radioOption3": "Confinamento Total",
                        "radioOption4": "Semi-Confinamento",
                        "submit": "Avançar",
                    },
                    "VegetalProduction": {
                        "title": "Produção Agrícola",
                        "description": "Selecione as culturas agrícolas presentes na sua herdade e indique a área cultivada (em hectares).",
                        "cultivated_area": "Área Cultivada",
                        "hectare_placeholder": "0 ha",
                        "inputBoxOption1": "Cereais e forragens",
                        "inputBoxOption2": "Pastagem natural",
                        "inputBoxOption3": "Pastagem de regadio",
                        "inputBoxOption4": "Milho",
                        "inputBoxOption5": "Arroz",
                        "inputBoxOption6": "Outras culturas de regadio",
                        "inputBoxOption7": "Vinha",
                        "inputBoxOption8": "Olival",
                        "inputBoxOption9": "Amendoal",
                        "inputBoxOption10": "Outros pomares",
                        "inputBoxOption11": "Hortícolas",
                    },
                    "FarmType": {
                        "description": "Indique informações sobre os tipos de produção (animal, agrícola, florestal) e se realiza mobilização de solo",
                        "soilMobility": "Existe mobilização do solo?",
                        "spicesTitle": "Tipologia da herdade",
                        "checkboxOption1": "Produção Animal",
                        "checkboxOption2": "Produção Agrícola",
                        "checkboxOption3": "Produção Florestal",
                    },
                    "FuelSpent": {
                        "title": "Combustíveis",
                        "description": "Indique o consumo anual de combustível na sua herdade para cada tipo de combustível utilizado.",
                        "fuelOptions1": "Gasóleo",
                        "fuelOptions2": "Gasolina",
                        "calculate": "Calcular!",
                        "modalTitle": "Descubra o seu impacto ambiental",
                        "modalDescription": "Para aceder ao relatório detalhado com a sua pegada de carbono, insira o seu e-mail.",
                        "buttonOk": "Ver a minha Pegada de Carbono",
                        "buttonCancel": "Cancelar",

                    },
                    "ConsultSpecialist": {
                        "title": "Consultar Especialista",
                        "description": "Quer saber mais sobre como podemos ajudar? Preencha o formulário abaixo e entraremos em contacto para apresentar as soluções mais adequadas à sua exploração.",
                        "submit": "Submeter",
                    }
                }
            },
            en: {
                translation: {
                    "welcome": "Welcome to AgroInsider!",
                    "calculate_carbon_footprint": "Start Calculation",
                    "find_more": "Find out more",
                    "general-information": "General Information",
                    "homepage_carbon_title_logo": "Welcome to Carbon Calc",
                    "homepage_carbon_description_logo1": "Here you can calculate your carbon footprint, learn how to reduce it",
                    "homepage_carbon_description_logo2": "and improving the sustainability of your farm.",
                    "homepage_carbon_title1": "Measure",
                    "homepage_carbon_title2": "Learn",
                    "homepage_carbon_title3": "Improve",
                    "homepage_carbon_description1": "Easily calculate your carbon footprint.",
                    "homepage_carbon_description2": "Learn about the carbon footprint in agriculture.",
                    "homepage_carbon_description3": "Improve the sustainability of your farm.",
                    "FarmProfile": {
                        "title": "Farm Profile",
                        "description": "Collect information about your agricultural activities. The data is used to calculate CO2 emissions and help reduce the environmental impact of your farm. Please fill out all sections carefully.",
                        "farmName": "Farm Name",
                        "location": "Geographical Location",
                        "size": "Farm Size (in hectares)",
                        "farmType": "Type of Farm",
                        "animalProduction": "Animal Production",
                        "agriculturalProduction": "Agricultural Production",
                        "mixed": "Mixed",
                        "submit": "Continue",
                    },
                    "Animal Production": {
                        "title": "Animal Production",
                        "spicesTitle": "Homestead typology",
                        "spicesOption1": "Beef",
                        "spicesOption2": "Sheep",
                        "spicesOption3": "Birds",
                        "spicesOption4": "Rabbits",
                        "spicesOption5": "Other",
                        "methods": "What creation method was used?",
                        "radioOption1": "Intensive Grazing",
                        "radioOption2": "Semi-Intensive Grazing",
                        "radioOption3": "Total Confinement",
                        "radioOption4": "Semi-Confinement",
                        "submit": "Next",
                    },
                    "VegetalProduction": {
                        "title": "Vegetal Production",

                    },

                }
            }
        },
        lng: "pt", // idioma padrão
        fallbackLng: "pt", // idioma de fallback
        interpolation: {
            escapeValue: false // react já faz a escape
        }
    });

export default i18n;
